import React from 'react';
import styles from './styles';

const OriginalContentData = props => {

  const parseEligibility = (text) => {
    let exclusionStart = text.toLowerCase().indexOf('exclusion criteria')

    let inBlock = text.substring(0, exclusionStart)
    let exBlock = text.substring(exclusionStart, text.length)
    return (`${inBlock}\n\n${exBlock}`)
  }

    const properties = [
        ['NCT', <span>{props.nctId}</span>],
        ['Brief Title', <span>{props.data.title}</span>],
        ['Official Title', <span>{props.data.official_title}</span>],
        ['Brief Summary',  <span>{props.data.briefDescription}</span>],
        ['Detailed Description',  <span>{props.data.detailedDescription && props.data.detailedDescription !== " " ? props.data.detailedDescription : 'N/A'}</span>],
        ['Conditions',  props.data.condition && props.data.condition.length > 0
            ? <ul style={styles.list}>{props.data.condition.map((condition, i) => <li style={styles.listItem} key={i}>
                <span style={{display: 'block'}}>{condition}</span>
            </li>)
            }</ul>
            : 'N/A'
        ],
        ['Study Arms', <span>{props.data.arms}</span>],
        ['Primary Outcome', props.data.primaryOutcome
            ? <ul style={styles.list}>{props.data.primaryOutcome.map((outcome, i) => <li style={styles.listItem} key={i}>
                <span style={{marginBottom: '5px', display: 'block'}}><b>Measure:</b> {outcome.measure ? outcome.measure : 'N/A'}</span>
                <span style={{display: 'block'}}><b>Time Frame:</b> {outcome.time_frame ? outcome.time_frame : 'N/A'}</span>
                </li>)
            }</ul>
            : 'N/A'
        ],
        ['Eligibility Criteria',  <span style={{whiteSpace: 'pre-wrap'}}>{parseEligibility(props.data.eligibilityCriteria)}</span>],
        ['Keywords', props.data.keywords && props.data.keywords.length > 0
            ? <ul style={styles.list}>{props.data.keywords.map((keyword, i) => <li style={styles.listItem} key={i}>
                <span style={{display: 'block'}}>{keyword}</span>
                </li>)
             }</ul>
            : 'N/A'
        ]
    ]

    return(
        <div style={styles.container}>
            {properties.map((propObj, i) => <div key={i} style={styles.dataContainer}>
                <h5 style={styles.property}>{propObj[0]}</h5>
                <div style={styles.value}>{propObj[1] || 'N/A'}</div>
            </div>)}
        </div>
    )
}

export default OriginalContentData;
